import React from 'react';
import { css } from '@emotion/react';
import { BlockMapBuilder, convertFromHTML, EditorState, Modifier } from 'draft-js';

import { DraftJsStyleButtonProps } from '../ui/EditableInput/DraftJSPlugins/draft-js-buttons/src';
import DropdownComponent, { DropdownPropsRef } from '../ui/Input/Basics/DropdownComponent';
import { SavedReplyList } from './SavedReplyList';
import { SavedReplyFragment } from '$/GraphQL/schema/types';
import { Popup } from '../ui/Popup';
import { markdownToHTML } from '$/shared/frontend/utils/MarkdownConverter';

export const AddSavedReplyButton: React.FC<DraftJsStyleButtonProps & { isRtl?: boolean }> = ({
  setEditorState,
  getEditorState,
  isRtl,
}) => {
  const ref = React.useRef<DropdownPropsRef>(null);

  const onClose = React.useCallback(() => {
    ref.current?.close();
  }, []);

  const onClickSavedReply = React.useCallback(
    (savedReply: SavedReplyFragment) => {
      const editorState = getEditorState();
      const blocksFromHTML = convertFromHTML(markdownToHTML(savedReply.content));

      const emptyState = EditorState.createEmpty();
      const fragment = BlockMapBuilder.createFromArray(
        blocksFromHTML.contentBlocks.length
          ? blocksFromHTML.contentBlocks
          : emptyState.getCurrentContent().getBlocksAsArray()
      );

      const newContent = Modifier.replaceWithFragment(
        editorState.getCurrentContent(),
        editorState.getSelection(),
        fragment
      );

      let newEditorState = EditorState.push(editorState, newContent, 'insert-characters');
      newEditorState = EditorState.forceSelection(newEditorState, newContent.getSelectionAfter());
      setEditorState(newEditorState);
      onClose();
    },
    [getEditorState, setEditorState, onClose]
  );

  return (
    <DropdownComponent
      ref={ref}
      css={css`
        position: initial;
      `}
      className='add-saved-reply-button'
      closeOnSelect={false}
    >
      <DropdownComponent.Reference>
        <Popup
          content='Insert saved reply'
          className='ml-0'
          hoverable
          trigger={
            <div
              className='flex justify-center items-center'
              onMouseDown={(e) => e.preventDefault()}
              css={css`
                padding: 0.25rem;
                height: 3rem;
                width: 3rem;
                color: #222222;
                font-size: 18px;
                transition:
                  background-color 0.2s,
                  color 0.2s;
                border-radius: 0.25rem;
                cursor: pointer;
                &:hover {
                  background: #707070;
                  color: #fff;
                }
              `}
            >
              <b>#</b>
            </div>
          }
        />
      </DropdownComponent.Reference>
      <DropdownComponent.Options placement='top' style={{ zIndex: '9999009' }}>
        <SavedReplyList isRtl={isRtl} onClickSavedReply={onClickSavedReply} onClose={onClose} />
      </DropdownComponent.Options>
    </DropdownComponent>
  );
};
